import { Box, Typography, Link } from "@mui/material";
import React from "react";
import Translate from "src/components/translate";
import { getSession } from "src/utils/jwt";

const Footer = () => {
  const isLoggedIn = getSession();
  // return (
  //   <Box
  //     sx={{
  //       backgroundColor: "#f7f7f700",
  //       marginLeft: isLoggedIn ? "10%" : "0",
  //       paddingBottom: "0.8rem",
  //       mt: 1,
  //     }}
  //   >
  //     <Typography
  //       variant="subtitle2"
  //       textAlign="center"
  //       sx={{ fontSize: "13px" }}
  //     >
  //       <Link
  //         href="https://magabit.net/terms-conditions"
  //         target="_blank"
  //         rel="noopener"
  //         underline="hover"
  //       >
  //         <Translate>global.terms_conditions</Translate>
  //       </Link>
  //       <span style={{ color: "#cccccc", margin: "0 8px" }}>•</span>
  //       <Link
  //         href="https://magabit.net/privacy-policy"
  //         target="_blank"
  //         rel="noopener"
  //         underline="hover"
  //       >
  //         <Translate>global.privacy_policy</Translate>
  //       </Link>
  //       <span style={{ color: "#cccccc", margin: "0 8px" }}>•</span>
  //       <Link
  //         href="https://magabit.net/refund-billing-policy"
  //         target="_blank"
  //         rel="noopener"
  //         underline="hover"
  //       >
  //         <Translate>global.refund_billing</Translate>
  //       </Link>
  //       <span style={{ color: "#cccccc", margin: "0 8px" }}>•</span>
  //       <Link
  //         href="https://magabit.net/cancel-membership"
  //         target="_blank"
  //         rel="noopener"
  //         underline="hover"
  //       >
  //         <Translate>global.cancel_membership</Translate>
  //       </Link>
  //     </Typography>
  //   </Box>
  // );
return null;
};

export default Footer;
